import { TEmbListType, TEmbReceiveLogListingItem, TFilterEmb, EMB_ACTION_TO_DISPLAY_NAME_MAP } from '@monorepo/types';
import { ModifiersZTableModel } from '../../../table.modifier';
import { TTableCellTree } from '../../../table.type';
import { UiFilterModifiers } from '../../../../../filter/model/ui-filter.modifier';
import { TFilterGroupModel } from '../../../../../filter/model/ui-filter.types';
import moment from 'moment';

export const EMB_OUT_LOGS_LISITNG = {
  createFilterModel: (items: TFilterEmb[], prevModel?: TFilterGroupModel<TFilterEmb>) => {
    const createdNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: item.displayName || item.filterType,
        items: item.values.map((val) => ({
          value: val,
          isSelected: false,
        })),
        selectedValues: [],
      };
    });
    return prevModel
      ? UiFilterModifiers.updateFilterModelList(createdNewFilterModel, prevModel)
      : createdNewFilterModel;
  },
  createTableModel: (
    items: TEmbReceiveLogListingItem[],
    vendor_enabled: boolean,
    list_type: TEmbListType,
    vendorIdtoNameMap: Map<string, string>,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'emb_common.dateAndTime',
          },
          ...(vendor_enabled
            ? [
                {
                  type: 'TEXT_CELL',
                  text: 'emb_common.recieved_from',
                } as TTableCellTree,
              ]
            : []),
          {
            type: 'TEXT_CELL',
            text: 'emb_common.tags_count',
          },
          {
            type: 'TEXT_CELL',
            text: 'emb_common.emb_sent_qty',
          },
          {
            type: 'TEXT_CELL',
            text: 'emb_common.emb_dispatch_qty',
          },
          ...(list_type === 'AUDIT_LOG'
            ? [
                {
                  type: 'TEXT_CELL',
                  text: 'emb_common.action_taken',
                } as TTableCellTree,
              ]
            : []),
          {
            type: 'TEXT_CELL',
            text: 'emb_common.details',
            stickyType: 'RIGHT',
          },
          ...(list_type === 'TRANSACTION_LOG'
            ? [
                {
                  type: 'TEXT_CELL',
                  text: 'emb_common.action',
                  stickyType: 'RIGHT',
                } as TTableCellTree,
              ]
            : []),
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.eventTime ? moment(item.eventTime).format('DD-MM-YYYY HH:mm') : '--',
            },
            ...(vendor_enabled
              ? [
                  {
                    type: 'TEXT_CELL',
                    text: item.vendors[0], //array of vendors
                  } as TTableCellTree,
                ]
              : []),
            {
              type: 'TEXT_CELL',
              text: item.tagsCount,
            },
            {
              type: 'TEXT_CELL',
              text: item.sentQty,
            },
            {
              type: 'TEXT_CELL',
              text: item.dispatchedQty,
            },
            ...(list_type === 'AUDIT_LOG'
              ? [
                  {
                    type: 'TEXT_CELL',
                    text: EMB_ACTION_TO_DISPLAY_NAME_MAP[item.lastAction] || item.lastAction,
                  } as TTableCellTree,
                ]
              : []),
            {
              type: 'ACTION_CELL',
              actionType: 'VIEW',
              customTxt: 'emb_common.view',
            },
            ...(list_type === 'TRANSACTION_LOG'
              ? [
                  {
                    type: 'ACTION_CELL',
                    actionType: 'DELETE',
                    customTxt: 'emb_common.remove',
                  } as TTableCellTree,
                ]
              : []),
          ],
        };
      },
    );
  },
};
